/**
 * Shared parlay statistics helpers.
 *
 * Keeps the hit-rate denominator correct in one place: several surfaces
 * previously derived it from a raw total (`total - pending - voided`, or
 * `wins / total`), which silently includes PUSH results and understates the
 * hit rate once any parlay pushes.
 */

/**
 * Parlay hit rate as a percentage over DECIDED parlays only (won + lost).
 *
 * Push, void, and pending are excluded on purpose: a push or void refunds the
 * stake, it is neither a win nor a loss, so counting it in the denominator
 * understates the hit rate. Returns null when nothing is decided yet, so callers
 * can render a dash (or coalesce to 0) instead of a misleading 0%.
 */
export function hitRatePct(won: number, lost: number): number | null {
  const decided = won + lost;
  return decided > 0 ? (won / decided) * 100 : null;
}
